// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"6703M":[function(require,module,exports,__globalThis) {
/* eslint-disable rulesdir/imports */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iconList", ()=>iconList);
parcelHelpers.export(exports, "useIconFilter", ()=>useIconFilter);
parcelHelpers.export(exports, "useCopyImport", ()=>useCopyImport);
parcelHelpers.export(exports, "IconSearchView", ()=>IconSearchView);
parcelHelpers.export(exports, "SkeletonIconItem", ()=>SkeletonIconItem);
parcelHelpers.export(exports, "IconSearchSkeleton", ()=>IconSearchSkeleton);
parcelHelpers.export(exports, "IconsPageSearch", ()=>IconsPageSearch);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _checkmarkCircle = require("@react-spectrum/s2/icons/CheckmarkCircle");
var _checkmarkCircleDefault = parcelHelpers.interopDefault(_checkmarkCircle);
var _close = require("@react-spectrum/s2/icons/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _s2 = require("@react-spectrum/s2");
var _iconAliasesJs = require("./iconAliases.js");
// @ts-ignore
var _svg = require("/packages/@react-spectrum/s2/s2wf-icons/*.svg");
var _svgDefault = parcelHelpers.interopDefault(_svg);
var _colorSearchData = require("./colorSearchData");
var _noSearchResults = require("@react-spectrum/s2/illustrations/linear/NoSearchResults");
var _noSearchResultsDefault = parcelHelpers.interopDefault(_noSearchResults);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
const iconList = Object.keys((0, _svgDefault.default)).map((name)=>({
        id: name.replace(/^S2_Icon_(.*?)(Size\d+)?_2.*/, '$1'),
        icon: (0, _svgDefault.default)[name].default
    }));
function useIconFilter() {
    let { contains } = (0, _reactAriaComponents.useFilter)({
        sensitivity: 'base'
    });
    return (0, _react.useCallback)((textValue, inputValue)=>{
        const trimmedInput = inputValue.trim();
        // If input is empty after trimming, show all items
        if (!trimmedInput) return true;
        // Check for alias matches
        for (const alias of Object.keys((0, _iconAliasesJs.iconAliases))){
            if (contains(alias, trimmedInput) && (0, _iconAliasesJs.iconAliases)[alias].includes(textValue)) return true;
        }
        // Also compare for substrings in the icon's actual name
        return textValue != null && contains(textValue, trimmedInput);
    }, [
        contains
    ]);
}
function useCopyImport() {
    let [copiedId, setCopiedId] = (0, _react.useState)(null);
    let timeout = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    let handleCopyImport = (0, _react.useCallback)((id)=>{
        if (timeout.current) clearTimeout(timeout.current);
        // Use underscore prefix for names starting with a number (invalid JS identifier)
        let importName = id.replace(/^(\d)/, '_$1');
        navigator.clipboard.writeText(`import ${importName} from '@react-spectrum/s2/icons/${id}';`).then(()=>{
            setCopiedId(id);
            timeout.current = setTimeout(()=>setCopiedId(null), 2000);
        }).catch(()=>{
            (0, _s2.ToastQueue).negative('Failed to copy import statement.');
        });
    }, []);
    return {
        copiedId,
        handleCopyImport
    };
}
function IconListBox({ items, copiedId, onAction, listBoxClassName }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Virtualizer), {
        layout: (0, _reactAriaComponents.GridLayout),
        layoutOptions: {
            minItemSize: new (0, _reactAriaComponents.Size)(64, 64),
            maxItemSize: new (0, _reactAriaComponents.Size)(64, 64),
            minSpace: new (0, _reactAriaComponents.Size)(12, 12),
            preserveAspectRatio: true
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
            onAction: (item)=>onAction(item.toString()),
            items: items,
            layout: "grid",
            className: listBoxClassName || " Za13 _UR3ltQc13 __NR3ltQc13 Tt13 Qt13 St13 Rt13",
            dependencies: [
                copiedId
            ],
            renderEmptyState: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.IllustratedMessage), {
                    styles: " IM13 HM13 JerlM8c13 GerlM8c13",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noSearchResultsDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                            children: "No results"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Content), {
                            children: "Try a different search term."
                        })
                    ]
                }),
            children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(IconItem, {
                    item: item,
                    isCopied: copiedId === item.id
                })
        })
    });
}
const itemStyle = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf13';
    else rules += ' _Le13';
    rules += ' Oh13';
    rules += ' OlOVIhfcebS7sd13';
    rules += ' OlOVIhfcebS7sd13';
    rules += ' _Mc13';
    rules += ' _Kd13';
    rules += ' Za13';
    rules += ' Fb13';
    if (props.isSelected) rules += ' g013';
    else if (props.isFocusVisible) rules += ' gH13';
    else if (props.isHovered) rules += ' gH13';
    else rules += ' gqlRAZb13';
    if (props.isSelected) rules += ' -_8sjo0b-pr13';
    else rules += ' -_8sjo0b-pt13';
    rules += ' uk13';
    rules += ' ucJ9TBTb13';
    rules += ' ud3Euai13';
    rules += ' uea13';
    rules += ' ugb13';
    rules += ' uhd13';
    rules += ' uje13';
    rules += ' u2NhKxcl13';
    rules += ' uic13';
    rules += ' -_6BNtrc-b13';
    rules += ' vFHT6Dd13';
    rules += ' xb13';
    rules += ' _xa13';
    rules += ' _Fd13';
    rules += ' _FnuYUweb13';
    rules += ' pt13';
    rules += ' oH5kTnc13';
    rules += ' nH5kTnc13';
    rules += ' kH5kTnc13';
    rules += ' jH5kTnc13';
    rules += ' Yd13';
    rules += ' Xb13';
    rules += ' _2b13';
    rules += ' sd13';
    rules += ' _ta13';
    rules += ' UR3ltQc13';
    rules += ' qR3ltQc13';
    rules += ' eb13';
    rules += ' _Ca13';
    rules += ' Sp13';
    rules += ' Rp13';
    rules += ' ri13';
    return rules;
};
function IconSearchView({ filteredItems, listBoxClassName }) {
    let { copiedId, handleCopyImport } = useCopyImport();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _colorSearchData.InfoMessage), {
                children: [
                    "Press an item to copy its import statement. See ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Link), {
                        href: "icons",
                        children: "Icons"
                    }),
                    " for more information."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconListBox, {
                items: filteredItems,
                copiedId: copiedId,
                onAction: handleCopyImport,
                listBoxClassName: listBoxClassName
            })
        ]
    });
}
function IconItem({ item, isCopied = false }) {
    let Icon = item.icon;
    let ref = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.ListBoxItem), {
        id: item.id,
        value: item,
        textValue: item.id,
        className: itemStyle,
        ref: ref,
        style: (0, _s2.pressScale)(ref),
        children: [
            isCopied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkCircleDefault.default), {
                styles: " ZAdaW3b13 FAdaW3b13"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                styles: " ZAdaW3b13 FAdaW3b13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " La13 _Yb13 _Nc13 Pc13 _7c13",
                children: isCopied ? 'Copied!' : item.id
            })
        ]
    });
}
function SkeletonIconItem({ item }) {
    const PlaceholderIcon = (0, _closeDefault.default);
    const ref = (0, _react.useRef)(null);
    const itemStyle = function anonymous(props) {
        let rules = " ";
        if (props.isFocusVisible) rules += ' _Lf13';
        else rules += ' _Le13';
        rules += ' Oh13';
        rules += ' OlOVIhfcebS7sd13';
        rules += ' OlOVIhfcebS7sd13';
        rules += ' _Mc13';
        rules += ' _Kd13';
        rules += ' Za13';
        rules += ' Fb13';
        if (props.isSelected) rules += ' g013';
        else if (props.isFocused) rules += ' gH13';
        else if (props.isHovered) rules += ' gH13';
        else rules += ' gqlRAZb13';
        if (props.isSelected) rules += ' -_8sjo0b-pr13';
        else rules += ' -_8sjo0b-pt13';
        rules += ' uk13';
        rules += ' ucJ9TBTb13';
        rules += ' ud3Euai13';
        rules += ' uea13';
        rules += ' ugb13';
        rules += ' uhd13';
        rules += ' uje13';
        rules += ' u2NhKxcl13';
        rules += ' uic13';
        rules += ' -_6BNtrc-b13';
        rules += ' vFHT6Dd13';
        rules += ' xb13';
        rules += ' _xa13';
        rules += ' _Fd13';
        rules += ' _FnuYUweb13';
        rules += ' pt13';
        rules += ' oH5kTnc13';
        rules += ' nH5kTnc13';
        rules += ' kH5kTnc13';
        rules += ' jH5kTnc13';
        rules += ' Yd13';
        rules += ' Xb13';
        rules += ' _2b13';
        rules += ' sd13';
        rules += ' _ta13';
        rules += ' UR3ltQc13';
        rules += ' qR3ltQc13';
        rules += ' eb13';
        rules += ' _Ca13';
        rules += ' Sp13';
        rules += ' Rp13';
        return rules;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.ListBoxItem), {
        id: item.id,
        value: item,
        textValue: "skeleton",
        className: itemStyle,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlaceholderIcon, {
                styles: " ZAdaW3b13 FAdaW3b13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " La13 _Yb13 _Nc13 Pc13 _7c13",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                    styles: " uk13 ucJ9TBTb13 ud3Euai13 uea13 ugb13 uhd13 uje13 u2NhKxcl13 uic13 -_6BNtrc-b13 vFHT6Dd13 xb13 _xa13 _Fd13 _FnuYUweb13 pt13",
                    children: "Name"
                })
            })
        ]
    });
}
function IconSearchSkeleton() {
    const mockItems = (0, _react.useMemo)(()=>Array.from({
            length: 140
        }, (_, i)=>({
                id: `skeleton-${i}`
            })), []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Skeleton), {
        isLoading: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Virtualizer), {
            layout: (0, _reactAriaComponents.GridLayout),
            layoutOptions: {
                minItemSize: new (0, _reactAriaComponents.Size)(64, 64),
                maxItemSize: new (0, _reactAriaComponents.Size)(64, 64),
                minSpace: new (0, _reactAriaComponents.Size)(12, 12),
                preserveAspectRatio: true
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
                items: mockItems,
                layout: "grid",
                className: " _ub13 _Na13 Pa13 Za13 _UR3ltQc13 __NR3ltQc13",
                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonIconItem, {
                        item: item
                    })
            })
        })
    });
}
function IconsPageSearch() {
    let filter = useIconFilter();
    let { copiedId, handleCopyImport } = useCopyImport();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Autocomplete), {
            filter: filter,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " sd13 _ta13 UH5kTnc13 qH5kTnc13",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SearchField), {
                        size: "L",
                        "aria-label": "Search icons",
                        placeholder: "Search icons"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _colorSearchData.InfoMessage), {
                        children: [
                            "Press an item to copy its import statement. See ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Link), {
                                href: "icons",
                                children: "Icons"
                            }),
                            " for more information."
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconListBox, {
                        items: iconList,
                        copiedId: copiedId,
                        onAction: handleCopyImport,
                        listBoxClassName: " FKcPCPb13 Za13 Ka13 _Na13 Pa13 _UR3ltQc13 __NR3ltQc13"
                    })
                ]
            })
        })
    });
}

},{"0":"8LTfO","1":"jxwTK","2":"2jn6Y","3":"3d2bI","4":"58tai","5":"axfi2","6":"czuMt","7":"eqINt","8":"bPRiM","9":"jxeRV","10":"dfFdL","11":"kEmpe","12":"1zrMH","react/jsx-runtime":"2Is6Z","react-aria-components":[["Autocomplete","92IrI"],["GridLayout","e73PK"],["ListBox","dNdIK"],["ListBoxItem","dNdIK"],["Size","46Qnl"],["useFilter","cQ2N2"],["Virtualizer","2WSF6"]],"@react-spectrum/s2/icons/CheckmarkCircle":"6hpGX","@react-spectrum/s2/icons/Close":"aI18O","@react-spectrum/s2":[["Content","10r6w"],["Heading","10r6w"],["Text","10r6w"],["IllustratedMessage","6oPVu"],["Link","42COX"],["pressScale","8Ufux"],["SearchField","5lOkR"],["Skeleton","1mUnF"],["ToastQueue","9R0uF"]],"./iconAliases.js":"iuo3C","/packages/@react-spectrum/s2/s2wf-icons/*.svg":"fSIv6","./colorSearchData":"1UrKQ","@react-spectrum/s2/illustrations/linear/NoSearchResults":"fvWSv","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iuo3C":[function(require,module,exports,__globalThis) {
// Maps common terms to potentially relevant S2 workflow icons.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iconAliases", ()=>iconAliases);
const iconAliases = {
    'add': [
        'New',
        'ProjectCreate'
    ],
    'again': [
        'Redo'
    ],
    'annotation': [
        'MusicNote',
        'StickyNote'
    ],
    'approve': [
        'BadgeVerified',
        'CheckmarkCircle'
    ],
    'arrow': [
        'ChevronDoubleLeft',
        'ChevronDoubleRight',
        'ChevronDown',
        'ChevronLeft',
        'ChevronRight',
        'ChevronUp'
    ],
    'attention': [
        'AlertDiamond',
        'AlertTriangle'
    ],
    'audio': [
        'MusicNote',
        'VolumeOff',
        'VolumeOne',
        'VolumeTwo'
    ],
    'begin': [
        'Play'
    ],
    'browser': [
        'WebNavBar',
        'WebPage'
    ],
    'call': [
        'DevicePhone'
    ],
    'camera': [
        'Image',
        'ImageAdd',
        'ImageBackgroundRemove'
    ],
    'cancel': [
        'Close',
        'CloseCaptions',
        'CloseCircle'
    ],
    'caret': [
        'ArrowHeadTool',
        'ChevronDoubleLeft',
        'ChevronDoubleRight',
        'ChevronDown',
        'ChevronLeft',
        'ChevronRight',
        'ChevronUp'
    ],
    'chat': [
        'Comment',
        'CommentCheckmark',
        'CommentHide',
        'CommentRemove',
        'CommentShow',
        'CommentText',
        'TextReplaceComment'
    ],
    'chevron': [
        'ArrowHeadTool'
    ],
    'clockwise': [
        'RotateCW'
    ],
    'close': [
        'Cancel'
    ],
    'comment': [
        'Feedback'
    ],
    'confirm': [
        'CheckBox'
    ],
    'connection': [
        'SocialNetwork'
    ],
    'conversation': [
        'Chat'
    ],
    'copy': [
        'Duplicate'
    ],
    'counterclockwise': [
        'RotateCCW'
    ],
    'create': [
        'Add',
        'AddCircle',
        'AddContent',
        'CalendarAdd',
        'DataAdd',
        'FileAdd',
        'FolderAdd',
        'ImageAdd',
        'New',
        'ProjectAddInto',
        'TextAdd',
        'UserAdd'
    ],
    'crown': [
        'PremiumIcon'
    ],
    'date': [
        'Calendar',
        'CalendarAdd',
        'CalendarDay',
        'CalendarEdit',
        'CalendarWeek'
    ],
    'decrease': [
        'ChevronDown',
        'OrderOneDown',
        'SortDown',
        'ThumbDown'
    ],
    'delete': [
        'CommentRemove',
        'ImageBackgroundRemove',
        'RemoveCircle'
    ],
    'developer': [
        'Code'
    ],
    'diagram': [
        'ChartBarVert',
        'ChartPie',
        'ChartTrend'
    ],
    'directory': [
        'Folder',
        'FolderAdd',
        'FolderBreadcrumb',
        'FolderClock',
        'FolderMoveTo',
        'FolderOpen',
        'FolderSearch'
    ],
    'display': [
        'ViewGrid',
        'ViewGridFluid',
        'ViewList',
        'ViewTransparency'
    ],
    'doc': [
        'File',
        'FileAdd',
        'FileConvert',
        'FileText',
        'FileUser'
    ],
    'document': [
        'File',
        'FileAdd',
        'FileConvert',
        'FileText',
        'FileUser'
    ],
    'download': [
        'SaveFloppy'
    ],
    'duplicate': [
        'Copy'
    ],
    'edit': [
        'PenBrush'
    ],
    'end': [
        'Cancel',
        'Close',
        'CloseCaptions',
        'CloseCircle'
    ],
    'enlarge': [
        'ZoomIn',
        'ZoomOut'
    ],
    'eye': [
        'ViewGrid',
        'ViewGridFluid',
        'ViewList',
        'ViewTransparency'
    ],
    'favorite': [
        'Heart',
        'Star',
        'StarFilled'
    ],
    'feedback': [
        'Comment',
        'CommentCheckmark',
        'CommentHide',
        'CommentRemove',
        'CommentShow',
        'CommentText',
        'TextReplaceComment'
    ],
    'film': [
        'MovieCamera',
        'Video'
    ],
    'find': [
        'FolderSearch',
        'Search'
    ],
    'finish': [
        'Close',
        'CloseCaptions',
        'CloseCircle'
    ],
    'funnel': [
        'Filter'
    ],
    'gear': [
        'DataSettings',
        'Settings',
        'TextVariableFontSettings',
        'UserSettings'
    ],
    'graph': [
        'ChartBarVert',
        'ChartPie',
        'ChartTrend'
    ],
    'horizontal': [
        'RectangleHoriz',
        'UnlinkHoriz'
    ],
    'house': [
        'Home'
    ],
    'image': [
        'Camera',
        'CameraProperties',
        'MovieCamera'
    ],
    'increase': [
        'ChevronUp',
        'OrderOneUp',
        'SortUp',
        'ThumbUp'
    ],
    'information': [
        'InfoCircle'
    ],
    'insert': [
        'Add',
        'AddCircle',
        'AddContent',
        'CalendarAdd',
        'DataAdd',
        'FileAdd',
        'FolderAdd',
        'ImageAdd',
        'New',
        'ProjectAddInto',
        'ProjectCreate',
        'TextAdd',
        'UserAdd'
    ],
    'internet': [
        'WebNavBar',
        'WebPage'
    ],
    'keyboard': [
        'Key'
    ],
    'label': [
        'Tag'
    ],
    'like': [
        'Heart'
    ],
    'list': [
        'MenuHamburger'
    ],
    'location': [
        'PinOff',
        'PinOn'
    ],
    'lookup': [
        'FindAndReplace',
        'FolderSearch',
        'Search'
    ],
    'love': [
        'Heart'
    ],
    'lower': [
        'ChevronDown',
        'OrderOneDown',
        'SortDown',
        'ThumbDown'
    ],
    'magnify': [
        'FolderSearch',
        'Search',
        'ZoomIn',
        'ZoomOut'
    ],
    'map': [
        'Location',
        'PinOff',
        'PinOn'
    ],
    'marker': [
        'Flag'
    ],
    'member': [
        'FileUser',
        'User',
        'UserAdd',
        'UserAvatar',
        'UserAvatarCursor',
        'UserEdit',
        'UserFollowing',
        'UserGroup',
        'UserLock',
        'UserSettings'
    ],
    'menu': [
        'ListBulleted',
        'ListMultiSelect',
        'ListNumbered',
        'ViewList'
    ],
    'message': [
        'Chat',
        'Comment',
        'CommentCheckmark',
        'CommentHide',
        'CommentRemove',
        'CommentShow',
        'CommentText',
        'TextReplaceComment'
    ],
    'minus': [
        'CommentRemove',
        'Delete',
        'ImageBackgroundRemove',
        'RemoveCircle'
    ],
    'modify': [
        'CalendarEdit',
        'Edit',
        'EditNo',
        'UserEdit'
    ],
    'movie': [
        'Video'
    ],
    'music': [
        'AudioWave'
    ],
    'network': [
        'CloudStateSlowConnection',
        'SlowConnectionCircle'
    ],
    'new': [
        'Add',
        'AddCircle',
        'AddContent',
        'CalendarAdd',
        'DataAdd',
        'FileAdd',
        'FolderAdd',
        'ImageAdd',
        'ProjectAddInto',
        'ProjectCreate',
        'TextAdd',
        'UserAdd'
    ],
    'next': [
        'StepForward'
    ],
    'online': [
        'Cloud',
        'CloudStateDisconnected',
        'CloudStateError',
        'CloudStateInProgress',
        'CloudStatePaused',
        'CloudStatePending',
        'CloudStateSlowConnection',
        'UploadToCloud'
    ],
    'options': [
        'DataSettings',
        'PluginGear',
        'Settings',
        'TextVariableFontSettings',
        'UserSettings'
    ],
    'padlock': [
        'Lock',
        'LockOpen',
        'UserLock',
        'UsersLock'
    ],
    'person': [
        'FileUser',
        'User',
        'UserAdd',
        'UserAvatar',
        'UserAvatarCursor',
        'UserEdit',
        'UserFollowing',
        'UserGroup',
        'UserLock',
        'UserSettings'
    ],
    'phone': [
        'CallCenter'
    ],
    'photo': [
        'Camera',
        'CameraProperties',
        'Image',
        'ImageAdd',
        'ImageBackgroundRemove',
        'MovieCamera'
    ],
    'picture': [
        'Camera',
        'CameraProperties',
        'Image',
        'ImageAdd',
        'ImageBackgroundRemove',
        'MovieCamera'
    ],
    'pin': [
        'Location'
    ],
    'place': [
        'Location'
    ],
    'plus': [
        'Add',
        'AddCircle',
        'AddContent',
        'CalendarAdd',
        'DataAdd',
        'FileAdd',
        'FolderAdd',
        'ImageAdd',
        'New',
        'ProjectAddInto',
        'TextAdd',
        'UserAdd'
    ],
    'profile': [
        'FileUser',
        'User',
        'UserAdd',
        'UserAvatar',
        'UserAvatarCursor',
        'UserEdit',
        'UserFollowing',
        'UserGroup',
        'UserLock',
        'UserSettings'
    ],
    'program': [
        'Code'
    ],
    'pro': [
        'PremiumIcon'
    ],
    'raise': [
        'ChevronUp',
        'OrderOneUp',
        'SortUp',
        'TextIncrease',
        'ThumbUp'
    ],
    'reload': [
        'DataRefresh',
        'Refresh'
    ],
    'remove': [
        'Delete'
    ],
    'repeat': [
        'Redo'
    ],
    'reverse': [
        'Undo'
    ],
    'save': [
        'Download',
        'Bookmark',
        'BookmarkSingleFilled'
    ],
    'schedule': [
        'Calendar',
        'CalendarAdd',
        'CalendarDay',
        'CalendarEdit',
        'CalendarWeek'
    ],
    'script': [
        'Code'
    ],
    'search': [
        'FindAndReplace'
    ],
    'secure': [
        'Lock',
        'LockOpen',
        'UserLock',
        'UsersLock'
    ],
    'send': [
        'DataUpload',
        'Share',
        'ShareAndroid',
        'Upload',
        'UploadToCloud'
    ],
    'settings': [
        'PluginGear'
    ],
    'share': [
        'Send'
    ],
    'sound': [
        'AudioWave',
        'MusicNote',
        'VolumeOff',
        'VolumeOne',
        'VolumeTwo'
    ],
    'start': [
        'Play'
    ],
    'stop': [
        'Cancel',
        'Close',
        'CloseCaptions',
        'CloseCircle',
        'Pause',
        'PauseCircle'
    ],
    'store': [
        'SaveFloppy'
    ],
    'subtract': [
        'CommentRemove',
        'Delete',
        'ImageBackgroundRemove',
        'RemoveCircle'
    ],
    'telephone': [
        'CallCenter',
        'DevicePhone'
    ],
    'tick': [
        'CheckBox'
    ],
    'time': [
        'Clock',
        'ClockPending',
        'FolderClock'
    ],
    'trash': [
        'Delete'
    ],
    'unlock': [
        'FolderOpen',
        'LockOpen',
        'OpenIn'
    ],
    'up': [
        'TextIncrease'
    ],
    'verified': [
        'CheckmarkCircle'
    ],
    'versus': [
        'Compare'
    ],
    'vertical': [
        'ChartBarVert'
    ],
    'video': [
        'MovieCamera'
    ],
    'volume': [
        'AudioWave'
    ],
    'vs': [
        'Compare'
    ],
    'warning': [
        'AlertDiamond',
        'AlertTriangle',
        'CloudStateError'
    ],
    'watch': [
        'Clock',
        'ClockPending',
        'FolderClock'
    ],
    'wifi': [
        'SocialNetwork'
    ],
    'wireless': [
        'SocialNetwork'
    ],
    'write': [
        'CalendarEdit',
        'Edit',
        'EditNo',
        'PenBrush',
        'UserEdit'
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8LTfO":[function() {},{}],"jxwTK":[function() {},{}],"2jn6Y":[function() {},{}],"3d2bI":[function() {},{}],"58tai":[function() {},{}],"axfi2":[function() {},{}],"czuMt":[function() {},{}],"eqINt":[function() {},{}],"bPRiM":[function() {},{}],"jxeRV":[function() {},{}],"dfFdL":[function() {},{}],"kEmpe":[function() {},{}],"1zrMH":[function() {},{}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=icons.3bc5d86e.js.map
